<template>
  <v-combobox
    class="tag-management"
    v-model="model"
    :filter="filter"
    :hide-no-data="!search"
    :items="$store.getters['campaign/tags']"
    :search-input.sync="search"
    item-text="tag"
    item-value="id"
    hide-selected
    label="Add a tag"
    multiple
    small-chips
    solo
    flat
  >
    <template v-slot:no-data>
      <v-list-tile>
        <span class="subheading">Press enter to create</span>
        <v-chip label outline small color="#A1A9C3">
          {{ search }}
        </v-chip>
      </v-list-tile>
    </template>
    <template v-slot:selection="{ item, parent, selected }">
      <v-chip
        v-if="item === Object(item)"
        color="#A1A9C3"
        :selected="selected"
        label
        small
        outline
        class="lgrm-chip"
      >
        <span class="pr-2">
          {{ item.tag }}
        </span>
        <v-icon small @click="deleteTag(item, parent)">close</v-icon>
      </v-chip>
    </template>
    <template v-slot:item="{ index, item }">
      <v-list-tile-content>
        <v-text-field
          v-if="editing === item"
          v-model="editingText"
          autofocus
          flat
          background-color="transparent"
          hide-details
          solo
          @keyup.enter="edit(index, item)"
        ></v-text-field>
        <v-chip class="lgrm-chip" v-else color="#A1A9C3" outline label small>
          {{ item.tag }}
        </v-chip>
      </v-list-tile-content>
      <v-spacer></v-spacer>
      <v-list-tile-action @click.stop>
        <v-btn icon @click.stop.prevent="edit(index, item)">
          <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
        </v-btn>
      </v-list-tile-action>
    </template>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :right="true"
      timeout="3000"
    >
      Tag already added
      <v-btn color="pink" flat @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-combobox>
</template>

<script>
import campaignApi from '@/api/campaign'
import findIndex from 'lodash/findIndex'
import EventBus from '@/event_bus'

export default {
  name: 'TagManagement',
  props: {
    responseId: String,
    responseTagIds: Array
  },
  data: function() {
    const vm = this
    const model = this.responseTagIds.map(function(d) {
      return vm.$store.getters['campaign/tags'].find(t => d === t.id)
    })

    return {
      activator: null,
      attach: null,
      editing: null,
      editingText: '',
      index: -1,
      nonce: 1,
      menu: false,
      model: model,
      x: 0,
      search: null,
      y: 0,
      loading: false,
      snackbar: false
    }
  },
  computed: {
    selectedTags: function() {
      return tags
    }
  },
  watch: {
    model(val, prev) {
      console.log(val)
      if (val.length === prev.length) return
      const vm = this
      vm.loading = true
      vm.model = val.map((v, index) => {
        if (typeof v === 'string') {
          campaignApi
            .addResponseTag(
              vm.$router.currentRoute.params.campaignId,
              vm.responseId,
              v
            )
            .then(function(res) {
              vm.$store.commit('campaign/setTags', [
                ...vm.$store.getters['campaign/tags'],
                res.data.results
              ])
              vm.nonce++
              if (vm.responseTagIds.indexOf(res.data.results.id) === -1) {
                vm.responseTagIds.push(res.data.results.id)
                vm.model.splice(index, 1, res.data.results)
              } else {
                vm.snackbar = true
              }
              vm.loading = false
            })
        } else {
          if (vm.responseTagIds.indexOf(v.id) === -1)
            campaignApi
              .addResponseTag(
                vm.$router.currentRoute.params.campaignId,
                vm.responseId,
                v.tag
              )
              .then(function(res) {
                vm.nonce++
                vm.responseTagIds.push(v.id)
                vm.loading = false
              })
          else {
            vm.snackbar = true
          }
        }
        return v
      })
    }
  },

  methods: {
    edit(index, item) {
      const vm = this
      if (!this.editing) {
        this.editing = item
        this.editingText = item.tag
        this.index = index
      } else {
        campaignApi
          .updateTag(
            this.$router.currentRoute.params.campaignId,
            item.id,
            vm.editingText
          )
          .then(function(res) {
            vm.editing = null
            vm.index = -1
            vm.editingText = ''
            vm.loading = false
            const tags = [...vm.$store.getters['campaign/tags']]
            const i = findIndex(tags, d => d.id === res.data.results.id)
            console.log(i)
            tags.splice(i, 1, res.data.results)
            vm.$store.commit('campaign/setTags', tags, { root: true })
            EventBus.$emit('refreshTags')
          })
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false
      const hasValue = val => (val != null ? val : '')
      const text = hasValue(itemText)
      const query = hasValue(queryText)
      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      )
    },
    deleteTag: function(item, parent) {
      parent.selectItem(item)
      const vm = this
      vm.loading = true
      campaignApi
        .deleteResponseTag(
          vm.$router.currentRoute.params.campaignId,
          vm.responseId,
          item.id
        )
        .then(function(res) {
          vm.loading = false
        })
    },
    updateTag(tagId, text) {
      const vm = this
    }
  }
}
</script>

<style lang="stylus">
.tag-management {
    .v-text-field__details{
        display none
    }
    .v-input__slot {
        margin-bottom 0
    }
    &.v-text-field.v-text-field--solo .v-input__control {
        min-height auto
    }
    &.v-text-field.v-text-field--solo .v-input__append-inner, &.v-text-field.v-text-field--solo .v-input__prepend-inner {
        display none
    }
    &.v-text-field.v-text-field--enclosed .v-text-field__details, &.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
        padding-left 0
    }
    &.v-text-field.v-text-field--solo .v-label {
        color: $color-primary-light-5
        font-size 13px
    }
    .v-chip.lgrm-chip {
        border-radius 5px
        height 25px
        font-size 13px
        background $color-primary-light-7 !important
    }
}
</style>
